import {Component, OnInit} from '@angular/core';
import {LESSONS_LIST} from '../../const/common';
import {Router} from '@angular/router';

@Component({
  selector: 'app-subject-list',
  templateUrl: './subject-list.component.html',
  styleUrls: ['./subject-list.component.scss']
})
export class SubjectListComponent implements OnInit {
  lessons = LESSONS_LIST;

  constructor(private router: Router) {
  }

  ngOnInit(): void {
  }

  onClick(link: string): void {
    this.router.navigateByUrl(`subject-test-list/${link}`);
  }

}
